var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFire(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20.004,
    height: 24.004,
    viewBox: "0 0 20.004 24.004",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x2: 1.205,
    y2: 0.795,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fd7c42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#ff4f00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c6450c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x2: 1.258,
    y2: 0.742,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2c72f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.552,
    stopColor: "#fb9e14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e4680d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fire_",
    "data-name": "fire ",
    transform: "translate(-16.397 -8.855)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M19.249,16.04c-5.348,7.29-2.034,12.1.729,14.523a7.124,7.124,0,0,0,1.861,1.171c5.1,2.212,9.07.831,11.657-1.307,2.367-1.956,2.713-5.2,2.515-8.216-.167-2.54-.142-4.491.392-5.405a5.026,5.026,0,0,0-3.866,2.474c-.785-6.714-3.5-9.718-12.563-10.425,2.416,3.357,4.549,9.19.859,10.425-1.584.53-1.725-1.2-1.584-3.239Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M29.323,40.074c-2.977,4.33-.508,7.436,1.3,9.012a6.03,6.03,0,0,0,1.9,1.137,6.93,6.93,0,0,0,4.94.02c2.924-1.124,2.419-4.632,3.1-7.57a3.026,3.026,0,0,1,.709-1.338c-1.553,0-2.363.226-2.97.838.3-3.416-.626-5.766-5.22-8.067.979,2.8.224,8.2-1.227,8.846C30.979,43.347,29.667,42.952,29.323,40.074Z",
    transform: "translate(-8.207 -17.831)",
    fill: "url(#linear-gradient-2)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFire);
export default __webpack_public_path__ + "static/media/icon_fire.c887fd008c7f9e989cca487503754a29.svg";
export { ForwardRef as ReactComponent };